import type { ReactNode } from 'react';
import { ProcessStepsInfographic, type ProcessStepItem } from '@/components/ProcessStepsInfographic';

type Step = 1 | 2 | 3;

const STEP_DEFS: {
  step: Step;
  num: string;
  title: string;
  hint: string;
  icon: ReactNode;
}[] = [
  {
    step: 1,
    num: '01',
    title: 'Idéation',
    hint: 'Générer & valider',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <path d="M9 18h6M10 22h4M12 2a7 7 0 0 0-4 12.7V17h8v-2.3A7 7 0 0 0 12 2z" />
      </svg>
    ),
  },
  {
    step: 2,
    num: '02',
    title: 'Diagnostic / Faisabilité',
    hint: 'Analyser la viabilité',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
        <rect x="9" y="3" width="6" height="4" rx="1" />
        <path d="M9 12h6M9 16h4" />
      </svg>
    ),
  },
  {
    step: 3,
    num: '03',
    title: 'Modélisation',
    hint: 'BMC puis Business Plan',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <rect x="3" y="3" width="7" height="7" rx="1" />
        <rect x="14" y="3" width="7" height="7" rx="1" />
        <rect x="3" y="14" width="7" height="7" rx="1" />
        <rect x="14" y="14" width="7" height="7" rx="1" />
      </svg>
    ),
  },
];

type Props = {
  step: Step;
  step2Detail?: string;
  onSelect: (step: Step) => void;
};

export function ConceptionProcessSteps({ step, step2Detail, onSelect }: Props) {
  const steps: ProcessStepItem[] = STEP_DEFS.map((def) => ({
    num: def.num,
    title: def.title,
    hint: def.hint,
    sub: def.step === 2 ? step2Detail : undefined,
    icon: def.icon,
  }));

  return (
    <ProcessStepsInfographic
      steps={steps}
      columns={3}
      activeStep={step}
      onSelect={(s) => onSelect(s as Step)}
      ariaLabel="Étapes de conception"
    />
  );
}
